import styled from 'styled-components';
import PrimaryLook from '@assets/images/logo/primary_look.svg';
import IconLogo from '@assets/images/logo/icon_logo.svg';
import AgregatorLogo from '@assets/images/logo/agregator_logo.svg';
import PlatformLogo from '@assets/images/logo/platform_logo.svg'; 
import RoomLogo from '@assets/images/logo/room_logo.svg';
import PammLogo from '@assets/images/logo/pamm_logo.svg'; 
import { GatsbyImage } from "gatsby-plugin-image"

export const PrimaryLookImg = styled(PrimaryLook)`
  margin-top: 87px;
  margin-left: 81px;
`;

export const IconLogoImg = styled(IconLogo)`
  margin-top: 85px;
  margin-left: 153px;
`;

export const BuildingImg = styled(GatsbyImage)`
  width: 482px;
  height: 412px;
`;

export const AgregatorLogoImg = styled(AgregatorLogo)`
`;

export const PlatformLogoImg = styled(PlatformLogo)`
`;

export const RoomLogoImg = styled(RoomLogo)`
`;

export const PammLogoImg = styled(PammLogo)`
`;
